import React from "react";
import useAuth from "../Hooks/useAuth";

const PatientInfo = ({ appointment }) => {
  const { auth } = useAuth();

  return (
    <>
      <p>
        <a className="d-inline text-info text-decoration-none h4">
          {`${auth?.user.roles === 2 ? "Your" : "Patient's"}`} Info:{" "}
          {appointment?.patient_name}
        </a>
        <a
          data-bs-toggle="collapse"
          href="#collapseExample"
          role="button"
          aria-expanded="false"
          aria-controls="collapseExample"
          className="pb-1"
        >
          <i className="ms-3 fa-solid fa-caret-down"></i>
        </a>
      </p>
      <div className="collapse" id="collapseExample">
        <div className="card mb-4 ps-5 py-2">
          <table className="table table-sm table-borderless">
            <tbody>
              <tr>
                <td>
                  <h5>Name</h5>
                </td>
                <td>
                  <h6>{appointment?.patient_name}</h6>
                </td>
              </tr>
              <tr>
                <td>
                  <h5>Age</h5>
                </td>
                <td>
                  <h6>{appointment?.patient_age}</h6>
                </td>
              </tr>
              <tr>
                <td>
                  <h5>Gender</h5>
                </td>
                <td>
                  <h6>{appointment?.patient_gender}</h6>
                </td>
              </tr>
              <tr>
                <td>
                  <h5>Reason</h5>
                </td>
                <td>
                  <h6>{appointment?.reason}</h6>
                </td>
              </tr>
              <tr>
                <td>
                  <h5>Report</h5>
                </td>
                <td>
                  <h6>
                    <a
                      href={appointment?.report_image}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      {appointment?.report_image
                        ? appointment?.report_image.split("/").pop()
                        : "Unavailable"}
                    </a>
                  </h6>
                </td>
              </tr>
              <tr>
                <td>
                  <h5>Description</h5>
                </td>
                <td>
                  <h6>{appointment?.description}</h6>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default PatientInfo;
